module.exports = __webpack_public_path__ + "assets/img/glbtm.e33061d7.png";